module.exports = __webpack_public_path__ + "img/ZKGW5000A.7b377e28.png";